import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PtCoreActions } from '@pt/pt-core';

@Component({
  selector: 'pt-mfa',
  template: `
    <div class="loader-container">
      <pt-loading-page></pt-loading-page>
    </div>
  `,
  styles: [
    `
      .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
      }
    `,
  ],
})
export class MfaComponent implements OnInit {
  constructor(private store: Store) {}
  ngOnInit(): void {
    this.store.dispatch(PtCoreActions.notificationTwoFactorAuthentication());
  }
}
